export default __webpack_public_path__ + "static/media/img-16.925177e5.png";